import { IndustryTemplate } from '@/components';
import { roofingContent } from '@/data/industries/roofing';

export function RoofingPage() {
  return <IndustryTemplate content={roofingContent} />;
}
